import { render, staticRenderFns } from "./NavigationDrawerLecturesNav.vue?vue&type=template&id=4045930c"
import script from "./NavigationDrawerLecturesNav.vue?vue&type=script&lang=js"
export * from "./NavigationDrawerLecturesNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports